/**
 * Get the bounding client rect of a Spine element.
 * - For TextInput, we take the rect of its container.
 */
export function getSpineElementRect(element: Element) {
    const spineTextInputElement = element.closest('[data-spine-text-input]');
    const measured = spineTextInputElement ?? element;
    return measured.getBoundingClientRect();
}
